import { useState, useRef } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { MenuItem } from '@mui/material'

import * as S from './styles'

export type SelectMenuProps = {
  id?: string
  label: string
  options: string[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  hasBorder?: boolean
}

export const SelectMenu: React.FC<SelectMenuProps> = ({
  id,
  label,
  options,
  value,
  onChange,
  disabled,
  hasBorder = true
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleSelect = (value: string) => {
    onChange(value)
    handleClose()
  }

  return (
    <div ref={containerRef}>
      <S.StyledButton
        aria-describedby={id}
        aria-controls={open ? 'select-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        open={open}
        variant="contained"
        onClick={handleClick}
        disableElevation
        endIcon={<KeyboardArrowDownIcon color="primary" />}
        disabled={disabled}
        hasBorder={hasBorder}
      >
        {label}
        {!!value && ` • ${value}`}
      </S.StyledButton>
      <S.StyledMenu
        id="select-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': id
        }}
        elevation={0}
        minwidth={containerRef.current?.clientWidth}
      >
        {options.map((option) => (
          <MenuItem key={option} onClick={() => handleSelect(option)}>
            {option}
          </MenuItem>
        ))}
      </S.StyledMenu>
    </div>
  )
}
